// Empty polyfill for Node.js modules that are not needed in browser
module.exports = {};
